<form
  [formGroup]="practiceSelectForm"
  class="practice-select"
  [ngClass]="{
    'practice-select--is-adaptive': adaptive,
    'practice-select--is-2-column': displayOrganization && displayPractice
  }"
>

  <!-- Org Select Autocomplete -->
  <section class="auto org-auto" [style.display]="displayOrganization ? 'block' : 'none'">
    <button
      mat-icon-button
      aria-label="Close"
      class="auto__close practice-auto__close"
      (click)="onToggleFullpageAutocomplete($event)"
    >&times;</button>
    <button mat-icon-button (click)="onToggleFullpageAutocomplete($event)" class="auto__open-button" aria-label="Select organization">
      <mat-icon
        alt="Organization Select Icon"
        class="auto__icon practice-org__icon"
        data-qa="practiceSelectOrganizationButton"
      >work</mat-icon>
    </button>
    <p class="auto__wrapper org-auto__wrapper">
      <mat-icon
        alt="Select Organization Icon"
        class="auto__icon practice-auto__icon auto__icon--is-label"
      >work</mat-icon>
      <mat-form-field
        appearance="outline"
        class="auto__field org-auto__field"
        [ngClass]="{'auto--is-loading': loadingOrganizations}"
        #autocomplete_field
        floatLabel="never"
        data-qa="practiceSelectOrganizationField"
      >
        <input
          class="auto__input org-auto__input"
          matInput
          type="text"
          formControlName="organization"
          [matAutocomplete]="orgSelect"
          ofiAutoSelectOnTab
          (optionTabSelected)="onOrganizationSelect($event)"
          placeholder="Select an Organization"
          data-qa="practiceSelectOrganizationInput"
        >
        <mat-icon matSuffix class="auto__icon org-auto__icon">arrow_drop_down</mat-icon>
        <mat-autocomplete
          class="auto__autocomplete org-auto__autocomplete"
          #orgSelect="matAutocomplete"
          [displayWith]="displayEntity"
          (optionSelected)="onOrganizationSelect($event.option.value)"
          data-qa="practiceSelectOrganizationAuto"
        >
          <mat-option
            class="auto__option org-auto__option"
            *ngFor="let organization of filteredOrganizations | async"
            [value]="organization"
            [innerHTML]="organization?.Name | ofiHighlight: fields.organization.value?.Name || fields.organization.value"
            data-qa="practiceSelectOrganizationOption"
          ></mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </p>
  </section>

  <!-- Practice Select Autocomplete -->
  <section class="auto practice-auto" [style.display]="displayPractice ? 'block' : 'none'">
    <!-- FIXME: Tab focus becomes confused before finding close button. -->
    <button
    mat-icon-button
    aria-label="Close"
    class="auto__close practice-auto__close"
    data-qa="practiceSelectPracticeButton"
    (click)="onToggleFullpageAutocomplete($event)"
    >&times;</button>
    <!-- FIXME: Pressing enter on focused element doesn't work unless there's a form. -->
    <button mat-icon-button (click)="onToggleFullpageAutocomplete($event)" class="auto__open-button" aria-label="Select practice">
      <mat-icon
        alt="Active Practice Icon"
        class="auto__icon practice-auto__icon"
      >store</mat-icon>
    </button>
    <p class="auto__wrapper practice-auto__wrapper">
      <mat-icon
        alt="Active Practice Icon"
        class="auto__icon practice-auto__icon auto__icon--is-label"
      >store</mat-icon>
      <mat-form-field
        appearance="outline"
        class="auto__field practice-auto__field"
        [ngClass]="{'auto--is-loading': loadingPractices}"
        data-qa="practiceSelectPracticeField"
        #autocomplete_field
        floatLabel="auto"
      >
        <input
          class="auto__input practice-auto__input"
          matInput
          type="text"
          formControlName="practice"
          [matAutocomplete]="practiceSelect"
          placeholder="Select a Practice"
          ofiAutoSelectOnTab
          (optionTabSelected)="onPracticeSelect($event)"
          data-qa="practiceSelectPracticeInput"
        >
        <mat-icon matSuffix class="auto__icon practice-auto__icon">arrow_drop_down</mat-icon>
        <mat-autocomplete
          class="auto__autocomplete practice-auto__autocomplete"
          #practiceSelect="matAutocomplete"
          [displayWith]="displayEntity"
          (optionSelected)="onPracticeSelect($event.option.value)"
          data-qa="practiceSelectPracticeAuto"
        >
          <mat-option
            class="auto__option practice-auto__option"
            *ngFor="let practice of filteredPractices | async"
            [value]="practice"
            [innerHTML]="practice?.Name | ofiHighlight: fields.practice.value?.Name || fields.practice.value"
            data-qa="practiceSelectPracticeOption"
          ></mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </p>
  </section>
</form>
